import { render, staticRenderFns } from "./TooltipPopup.vue?vue&type=template&id=dc78e20c&"
import script from "./TooltipPopup.vue?vue&type=script&lang=ts&"
export * from "./TooltipPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports